import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/style.css";
import styles from "./Creator.module.sass";
import cn from "classnames";
import { useEffect, useState } from "react";
import Modal from "../../../components/Modal";
import Tooltip from "../../../components/Tooltip";
import { UseApi } from "../../../hooks/use-api";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import { AssignToBrandByAdmin } from "../../../Services/lib/brand";
import Loader from "../../../components/Loader";
import { useUser } from "../../../context";
import brand_text from "../../../i11/brand";

const SendMailModal = ({ data, visible, onClose }) => {
	const [emails, setEmails] = useState([]);
	const { locale } = useUser();
	const [role, setRole] = useState("1");
	const [{ data: res, isLoading }, sendMail] = UseApi({
		service: AssignToBrandByAdmin,
	});

	const sendBrandMail = (e) => {
		e.preventDefault();
		if (emails.length === 0) {
			ToastEmitter({
				msg: "Please promt atleast an email",
				type: "info",
			});
			return;
		}
		sendMail({
			_id: data._id,
			sendmails: emails,
			role: role,
			chosenOrg: data.brandname,
		});
	};

	useEffect(() => {
		if (res) {
			ToastEmitter({
				msg: "Invited Successfull",
				type: "success",
			});
			setEmails([]);
			onClose();
		}
	}, [res]);

	const RadioHandler = (e) => {
		setRole(e.target.value);
	};

	return (
		<Modal
			visible={visible}
			onClose={() => {
				onClose();
			}}
			children={
				data ? (
					<form onSubmit={sendBrandMail}>
						<div
							style={{
								fontSize: "20px",
								fontWeight: "600",
								lineHeight: 1.6,
								letterSpacing: "-.02em",
							}}
						>
							{brand_text[locale].add_b_m}
						</div>
						<div className={styles.spacer} />
						<div className={styles.label}>
							{brand_text[locale].email}
							{/* <Tooltip
								className={styles.tooltip}
								title={"tooltip"}
								icon="info"
								place={"right"}
							/> */}
						</div>
						<ReactMultiEmail
							required
							placeholder={brand_text[locale].email_ph}
							emails={emails}
							onChange={(_emails) => {
								setEmails([..._emails]);
							}}
							getLabel={(email, index, removeEmail) => {
								return (
									<div data-tag key={index}>
										{email}
										<span data-tag-handle onClick={() => removeEmail(index)}>
											x
										</span>
									</div>
								);
							}}
						/>
						<div className={styles.spacer} />
						<div className={styles.label}>
							{brand_text[locale].member_role}
							{/* <Tooltip
								className={styles.tooltip}
								title={"tooltip"}
								icon="info"
								place={"right"}
							/> */}
						</div>
						<div className={styles.radiowrap}>
							<input
								onChange={RadioHandler}
								checked={role === "1"}
								id="name1"
								value="1"
								name="name"
								type="radio"
								required
							/>
							<label htmlFor="name1">Brand admin</label>
							<input
								onChange={RadioHandler}
								id="name2"
								checked={role === "0"}
								value="0"
								name="name"
								type="radio"
								required
							/>
							<label htmlFor="name2">Marketplace operator</label>
						</div>
						<div className={styles.spacer} />
						<div className={styles.btns}>
							<button
								type="sumbit"
								className={cn("button", { [styles.button]: isLoading })}
							>
								{isLoading ? (
									<Loader white />
								) : (
									<span>{brand_text[locale].submit}</span>
								)}
							</button>
						</div>
					</form>
				) : (
					"Waiting for API"
				)
			}
		/>
	);
};

export default SendMailModal;
